import Form from '../_form';

const [ REDIRECTION_TIMEOUT, REDIRECTION_PATH ] = [ 3000, `${window.location.origin}/auth/sign-in` ];

export default class VerificationForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const form = document.querySelector(query);
        if (!form) return;

        this.finalizeForm();
    }

    async finalizeForm () {
        const formData = new FormData(this.form);

        const nonce = formData.get('verification_nonce');

        const token = formData.get('token');

        try {
            await fetch('/wp-json/auth/v1/verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ nonce_key: 'verification', nonce, token })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.NotificationManager.sendNotification('success', 'Successfully verified!', data.message);

                    setTimeout(() => window.location.href = REDIRECTION_PATH, REDIRECTION_TIMEOUT);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
        }
    }
}
